import { render, staticRenderFns } from "./RoomStudentsForm.vue?vue&type=template&id=1033c77c&"
import script from "./RoomStudentsForm.vue?vue&type=script&lang=ts&"
export * from "./RoomStudentsForm.vue?vue&type=script&lang=ts&"
import style0 from "./RoomStudentsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports